import { render, staticRenderFns } from "./CoverPhoto.vue?vue&type=template&id=f223f0ec&scoped=true&lang=pug&"
import script from "./CoverPhoto.vue?vue&type=script&lang=js&"
export * from "./CoverPhoto.vue?vue&type=script&lang=js&"
import style0 from "./CoverPhoto.vue?vue&type=style&index=0&id=f223f0ec&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f223f0ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
